const content = {
  page_title: "Journeys",
  journeys_overview_select: [
    {
      label: "Last 4 Weeks",
      type: "week",
      value: "4",
    },
    {
      label: "Last 8 Weeks",
      type: "week",
      value: "8",
    },
    {
      label: "Last 12 Week",
      type: "week",
      value: "12",
    },
  ],
  journey_overview_stats: [
    {
      label: "Journey Origin",
      value: "OriginLocationType",
      icon: "mdi-map-marker-circle",
      color: "primaryOutline",
      type: "string",
    },
    {
      label: "Average Stay Duration",
      value: "AvgStayDuration",
      icon: "mdi-clock-outline",
      color: "primary",
      type: "hours",
    },
    {
      label: "Fleet Utilization",
      value: "FleetUtilisation",
      icon: "mdi-chart-line-variant",
      color: "secondary",
      type: "percent",
    },
    {
      label: "Total Journeys",
      value: "TotalAssets",
      icon: "device_hub",
      color: "success",
      type: "number",
    },
  ],
  journeys_table: [
    {
      align: "start",
      text: "Origin",
      value: "OriginName",
      value_2: "OriginAddress",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "",
      value: "AvgJourneyTime",
      sortable: false,
      of_type: "to-from",
    },
    {
      text: "Destination",
      value: "DestinationName",
      value_2: "DestinationAddress",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Activity",
      value: "ActivityLevel",
      of_type: "text",
    },
    {
      text: "Assets at Destination",
      value: "AtDestination",
      of_type: "text",
    },
    {
      text: "Total Assets Moved",
      value: "TotalAssets",
      of_type: "text",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  devices_table: [
    {
      align: "start",
      text: "Device ID",
      value: "DeviceID",
      sortable: true,
      of_type: "link",
      identifier: "DeviceID",
      url: "/device/",
    },
    {
      text: "Asset ID",
      value: "AssetID",
      of_type: "text",
    },
    {
      text: "Stay Duration",
      value: "StayDuration",
      of_type: "hours",
    },
    {
      text: "M. Type",
      value: "LastMessageType",
      of_type: "secondary_icon",
    },
    {
      text: "Last Message",
      value: "LastMessage",
      of_type: "date",
    },
  ],
  device_filters: {
    //primary: ["All"],
    primary: [
      {
        label: "All",
        value: "All",
      },
    ],
    secondary: {
      list_checkbox: [
        {
          label: "Message Type",
          value: "MessageType",
          values: ["TwoWiFi", "Gps", "DownlinkAcknowledgement"],
        },
        {
          label: "Battery",
          value: "BatteryStatus",
          values: ["High", "Low", "Unknown"],
        },
        {
          label: "Device Status",
          value: "DeviceStatus",
          values: ["Fluid", "Static"],
        },
      ],
      range: [
        {
          label: "Stay Duration (in Hours)",
          min: 0,
          max: 500,
          value: "StayDuration",
        },
      ],
    },
  },
  arrival_time: {
    time: [
      {
        value: "0",
        label: "12 am",
      },
      {
        value: "1",
        label: "",
      },
      {
        value: "2",
        label: "2 am",
      },
      {
        value: "3",
        label: "",
      },
      {
        value: "4",
        label: "4 am",
      },
      {
        value: "5",
        label: "",
      },
      {
        value: "6",
        label: "6 am",
      },
      {
        value: "7",
        label: "",
      },
      {
        value: "8",
        label: "8 am",
      },
      {
        value: "9",
        label: "",
      },
      {
        value: "10",
        label: "10 am",
      },
      {
        value: "11",
        label: "",
      },
      {
        value: "12",
        label: "12 pm",
      },
      {
        value: "13",
        label: "",
      },
      {
        value: "14",
        label: "2 pm",
      },
      {
        value: "15",
        label: "",
      },
      {
        value: "16",
        label: "4 pm",
      },
      {
        value: "17",
        label: "",
      },
      {
        value: "18",
        label: "6 pm",
      },
      {
        value: "19",
        label: "",
      },
      {
        value: "20",
        label: "8 pm",
      },
      {
        value: "21",
        label: "",
      },
      {
        value: "22",
        label: "10 pm",
      },
      {
        value: "23",
        label: "",
      },
    ],
    days: [
      {
        value: "Monday",
        label: "Mon",
      },
      {
        value: "Tuesday",
        label: "Tue",
      },
      {
        value: "Wednesday",
        label: "Wed",
      },
      {
        value: "Thursday",
        label: "Thu",
      },
      {
        value: "Friday",
        label: "Fri",
      },
      {
        value: "Saturday",
        label: "Sat",
      },
      {
        value: "Sunday",
        label: "Sun",
      },
    ],
    colors: [
      "primaryGrey lighten-2",
      "primaryGrey",
      "primary lighten-3",
      "primary lighten-2",
      "primary",
    ],
  },
  filters: {
    //primary: ["All", "Watchlist"],
    primary: [
      {
        label: "All",
        value: "All",
      },
      {
        label: "Watchlist",
        value: "Watchlist",
      },
    ],
    secondary: {
      list_checkbox: [
        {
          label: "Activity",
          value: "ActivityLevel",
          values: ["High", "Mid", "Low"],
        },
      ],
      range: [
        {
          label: "Assets at Destination",
          min: 0,
          max: 0,
          value: "AtDestination",
        },
        {
          label: "Total Assets Moved",
          min: 0,
          max: 0,
          value: "TotalAssets",
        },
      ],
    },
  },
  text_expandAll: "EXPAND ALL",
  text_colapseAll: "COLAPSE ALL",
  assets_arrival_duration_select: [
    {
      label: "Last Week",
      value: "1",
    },
    {
      label: "Last 4 Weeks",
      value: "4",
    },
    {
      label: "Last 8 Weeks",
      value: "8",
    },
  ],
};

export { content };
